import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import ColumnButton from "./ColumnButton";
import { toast } from "react-toastify";

const DeleteColumnButton = ({
  text,
  action,
  id,
  onSuccessClick,
}: {
  text: string;
  action: any;
  id: any;
  onSuccessClick: () => void;
}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const onDelete = () => {
    dispatch(
      action({
        payload: {
          onSuccess: (message: string) => {
            toast.success(message);
            setShow(false);
            onSuccessClick();
          },
          onError: (message: string) => {
            toast.error(message);
          },
        },
        id: id,
      })
    );
  };
  return (
    <React.Fragment>
      <ColumnButton
        buttonType="delete"
        onClick={() => {
          return setShow(true);
        }}
      />
      <Modal isOpen={show} toggle={() => setShow(false)}>
        <ModalBody>
          <h5 className="fw-bold" style={{}}>
            {text}
          </h5>
        </ModalBody>
        <ModalFooter>
          <div className="w-100 d-flex flex-wrap justify-content-between">
            <Button
              color="danger"
              type="submit"
              onClick={() => setShow(false)}
              style={{ width: 100 }}
            >
              {t("DeleteComponent.Close")}
            </Button>
            <Button
              color="success"
              type="submit"
              onClick={() => onDelete()}
              style={{ width: 100 }}
            >
              {t("DeleteComponent.Delete")}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};
export default DeleteColumnButton;
